import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AudioComponent } from './audio.component';
import { IndexAudioComponent } from './index/index-audio.component';


const routes: Routes = [
  {
    path: '',
    component: AudioComponent,
    children: [
      {
        path: '',
        component: IndexAudioComponent
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AudioRoutingModule { }